<template>
  <div class="dashboard">
    <h2>Dashboard</h2>
    <div class="container-fluid default-padding">
      <div class="row">
        <div class="col-md-4">
          <new-leads-items @showNotes="showLeadNotes"/>
        </div>
        <div class="col-md-8">
          <hot-leads-items @showNotes="showLeadNotes"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <recent-activity-items @showNotes="showLeadNotes"/>
        </div>
        <div class="col-md-8">
          <status-summary-items/>
        </div>
      </div>
    </div>
    <Note v-if="showNote" :data="showNoteData" @close="showNote = false"/>
  </div>
</template>

<script>
import Note from '@/components/modals/Note'
import PerfectScrollbar from 'perfect-scrollbar'
import NewLeadsItems from "./includes/NewLeadsItem";
import HotLeadsItems from "./includes/HotLeadsItem";
import RecentActivityItems from "./includes/RecentActivityItem";
import StatusSummaryItems from "./includes/StatusSummaryItem";

export default {
  name: 'Index',
  components: {
    StatusSummaryItems, RecentActivityItems,
    HotLeadsItems, NewLeadsItems, Note
  },
  data() {
    return {
      showNote: false,
      showNoteData: {
        uuid: '',
        name: '',
      },
      ui: {
        ps: null,
        psHotLead: null,
        psRecent: null,
        psStatus: null,
        psStatuses: null,
        loading: false
      },
      allLeadsCount: 0,
    }
  },
  methods: {
    showLeadNotes({id, name}) {
      this.showNoteData.uuid = id;
      this.showNoteData.name = name;
      this.showNote = true;
    }
  },
  mounted() {
    this.$nextTick(() => {
      const scrollbarNewLead = document.getElementById('new-lead');
      const scrollbarHotLead = document.getElementById('hot-lead');
      const scrollbarRecentActivity = document.getElementById('recent-activity');

      this.ui.ps = new PerfectScrollbar(scrollbarNewLead);
      this.ui.psHotLead = new PerfectScrollbar(scrollbarHotLead);
      this.ui.psRecent = new PerfectScrollbar(scrollbarRecentActivity);
    });
  },
  beforeDestroy() {
    this.$nextTick(() => {
      this.ui.ps = null
      this.ui.psHotLead = null
      this.ui.psRecent = null
      this.ui.psStatus = null
      this.ui.psStatuses = null
    })
  },
}
</script>

<style lang="scss" scoped>
.dashboard {
  margin-top: 72px;
  margin-bottom: 46px;
  background-color: #f6f6f6;

  h2 {
    color: #000000;
    font-size: 21px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
    padding: 17.5px 42px;
    background-color: #f6f6f6;
    border-bottom: 1px solid #E7E8E8;
  }

  &::v-deep {
    .dashboard-item {
      background-color: rgba(255, 255, 255, 0.8);
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 12px;
      height: 528px;
      margin-bottom: 30px;

      .row {
        width: 100%;
        margin: 0 auto;
      }

      &.left {
        grid-column-start: 2;
        grid-column-end: 4;
      }

      &__header {
        max-height: 56px;
        padding: 17px 18px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      }

      h4 {
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        font-size: 17px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
        padding: 15px 18px;
        margin: 0;
      }

      .list {
        height: 100%;

        .row {
          position: relative;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          padding: 11px 12px;

          &:after {
            position: absolute;
            top: 99%;
            left: 50%;
            transform: translate(-50%, 0);
            content: '';
            display: block;
            height: 1px;
            width: calc(100% - 50px);
            color: rgba(0, 0, 0, 0.2);
            background: #E7E8E8;
          }

          &:first-child {
            font-weight: 500;
          }

          &:nth-child(even) {
            background-color: #F6F6F6;
          }

          div {
            color: #000000;
            font-size: 13px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 20px;
          }

          .col {
            position: relative;
            width: 100%;
            min-height: 1px;
            flex-basis: 0;
            -webkit-box-flex: 1;
            flex-grow: 1;
            max-width: 100%;

            &.text-right {
              text-align: right;
            }

            &.ml-5 {
              margin-left: 3rem !important;
            }

            &.mr-5 {
              margin-right: 3rem !important;
            }
          }
        }
      }
    }

    .status-summary {
      overflow: unset;
      overflow-x: initial !important;


      h4 {
        border-bottom: none !important;
      }

      &__col {
        padding: 11px 23px;

        &:first-child {
          border-right: 1px solid #EFEFEF;
        }
      }

      &__agents {
        overflow-y: auto;
        overflow-x: hidden;
        border-right: 1px solid #EFEFEF;
      }

      &__status {
        border-bottom: 1px solid #E7E8E8;
        transition: all 0.3s;
        cursor: pointer;

        &:hover {
          background-color: #f6f6f6;

          .status-summary__status-name {
            span {
              color: #000000;
            }
          }
        }
      }

      &__statuses {
        overflow-y: auto;
        height: 100%;

        & > .status-summary__status:nth-child(even) {
          background-color: #f6f6f6;
        }
      }

      &__status-count {
        padding: 14px 14px 14px 0;

        span {
          opacity: 0.7;
          color: #000000;
          font-size: 13px;
          letter-spacing: 0;
          line-height: 20px;
        }

        &:hover {
          span {
            opacity: 1;
          }
        }
      }

      &__status-name {
        width: 100%;
        padding: 14px 14px 14px 0;

        span {
          display: block;
          color: #0059E8;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 20px;
          width: fit-content;
          transition: all .3s;

          &:after {
            content: '';
            display: block;
            height: 1px;
            width: 0;
            background: #000000;
            transition: all .3s;
          }
        }
      }

      &__agent {
        padding: 14px 23px;
        color: rgba($color: #000000, $alpha: 0.7);
        font-size: 13px;
        letter-spacing: 0;
        line-height: 20px;
        border-bottom: 1px solid #E7E8E8;
        transition: all 0.3s;
        cursor: pointer;

        &_active {
          background-color: rgba(1, 122, 255, 0.1);
          color: #017aff;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 20px;
        }

        &:hover {
          background-color: rgba($color: #000000, $alpha: 0.05);
          color: #000000;
        }
      }

      &__body {
        height: 76%;
      }

      &__header {
        border-bottom: 1px solid #E7E8E8;

        span {
          color: #000000;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 20px;

          &:first-child {
            color: rgba(0, 0, 0, .46);
            font-size: 13px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 20px;
          }
        }
      }
    }

    .btn-note {
      border: none;
      background: none;
      padding: 0 0px;

      &:focus,
      &:active {
        border: none;
      }

      img {
        opacity: 0.46;
        background: rgba(236, 236, 236, 0);
        padding: 8px 10px;
        border-radius: 10px;
        transition: all 0.3s ease-in-out;

        &:hover {
          background: rgba(236, 236, 236, 1);
          opacity: 1;
          cursor: pointer;
        }
      }
    }

    .dsb-date {
      color: rgba(0, 0, 0, .4) !important;
      font-size: 11px !important;
      letter-spacing: 0 !important;
      line-height: 10px !important;
      text-align: right !important;
    }

    .lead-links {
      color: #0059E8;
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 20px;

      &:hover {
        &:after {
          width: 100%;
        }
      }

      &:after {
        width: 0;
        color: #0059E8;
        background: #0059E8;
      }
    }

    .scrollable {
      overflow-y: auto;
      height: 80%;

      &::-webkit-scrollbar {
        width: 5px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        opacity: 0.3
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, .3);
        border-radius: 8px;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
  }
}
</style>
